import { connect } from 'react-redux'
import { actions } from '@opallabs/wormhole'
import PdfExportModal from '.'

const mapDispatchToProps = (dispatch, ownProps) => ({
  createPdfExport: (params) => {
    dispatch(
      actions.createPdfExport({
        ...params,
        id: ownProps.id,
        type: ownProps.type,
      })
    )
  },
})

const ConnectedPdfExport = connect(null, mapDispatchToProps)(PdfExportModal)

export default ConnectedPdfExport
